// extracted by mini-css-extract-plugin
export var completionBody = "_ku-2";
export var completionCard = "_ku-0";
export var completionFooter = "_ku-3";
export var completionTitle = "_ku-1";